module.exports = __webpack_public_path__ + "static/media/mars-1.35819f0b.jpg";